import React from 'react'
import { useSelector } from 'react-redux';
import { useLanguage } from '../../../../../../context/LanguageProvider';
import { RootState } from '../../../../../../store/store';
import AppURL from '../../../../../../constants/AppURL';
import { formatMoney_2 } from '../../../../../../helpers/DateFormat';

const PrintLedgerView = ({ ledgerList, date_ne }: { ledgerList: any, date_ne: string }) => {
    const { language } = useLanguage();
    const { SOFTWARE_ORG, SET_FULL_SOFT_DATA } = useSelector((state: RootState) => state.software);
    const org_details = SOFTWARE_ORG?.org; const Org_Details = {};

    return (
        <div>
            <style>
                {`@media print {
                        @page {
                        size: A4 portrait;
                        page-break-before: always;
                        margin: 0.5in; 
                        border: 1px solid black;
                    }
                    }`}
            </style>
            <div className="relative p-1">
                <table className="w-full text-sm text-left rtl:text-right text-black">
                    <tbody>
                        <tr>
                            <td
                                className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}
                            >
                                {language === 'Eng' ? "Reg. No.: " : "दर्ता नं.:"}:{" "}
                                {org_details?.org_reg}
                            </td>
                            <td className="w-[25%]"></td>
                            <td className="w-[25%]"></td>
                            <td
                                align="right"
                                className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}
                            >
                                {language === 'Eng' ? "Phone: " : "फोन नम्बर:"}{" "}
                                {org_details?.org_phone}
                            </td>
                        </tr>
                        <tr>
                            <td
                                rowSpan={4}
                                className="w-[25%] font-medium text-black whitespace-nowrap"
                            >
                                <img
                                    width={60}
                                    height={60}
                                    src={AppURL.BaseURL + org_details?.logo}
                                    alt=""
                                />
                            </td>
                            <td
                                align="center"
                                colSpan={2}
                                className={`w-[25%] text-black font-semibold text-[18px] ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}
                            >
                                {language === 'Eng' ? org_details?.org_name : org_details?.org_name_nep}
                            </td>
                            <td className="w-[25%]"></td>
                        </tr>

                        <tr>
                            <td
                                align="center"
                                colSpan={2}
                                className={`w-[25%] text-black font-normal text-[12px] ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}
                            >
                                {language === 'Eng' ? org_details?.org_add : org_details?.org_add_nep}
                            </td>
                            <td
                                align="right"
                                className={`w-[25%] text-[11px] text-black font-normal ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}
                            >
                                {language === 'Eng' ? "Print Date: " : "मिति: "}{" "}
                                {SET_FULL_SOFT_DATA?.today_np}
                            </td>
                        </tr>
                        <tr>
                            <td
                                align="center"
                                colSpan={2}
                                className={`w-[25%] underline underline-offset-2 text-black font-semibold text-[15px] ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}
                            >
                                {language === 'Eng' ? "Ledger Report" : "लेजर रिपोर्ट"}
                            </td>
                            <td className="w-[25%]"></td>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div className="relative">
                <table className="w-full text-sm text-left whitespace-nowrap font-public-sans rounded-md text-slate-900">
                    <thead className="text-[11px] text-slate700 capitalize font-public-sans rounded-t-md bg-slate-200">
                        <tr>
                            <th scope="col" align='center' className={`px-2 py-0.5 border-y border-slate-600 w-16 ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                }`}>{language === 'Eng' ? "S.N." : "क्र.स."}</th>
                            <th scope="col" align='left' className={`px-2 py-0.5 border border-slate-600 ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                }`}>{language === 'Eng' ? "Date" : "मिति"}</th>
                            <th scope="col" align='center' className={`px-2 py-0.5 border border-slate-600 w-16 ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                }`}>{language === 'Eng' ? "Receipt No." : "रसिद नं."}</th>
                            <th scope="col" align='center' className={`px-2 py-0.5 border border-slate-600 ${language === 'Eng' ? "font-public-sans" : "font-nepali"}`}>{language === 'Eng' ? "TSN" : "लेनदेन नं."}</th>
                            <th scope="col" align='left' className={`px-2 py-0.5 border border-slate-600 ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                }`}>{language === 'Eng' ? "Particular Name" : "बिवरणहरु "}</th>
                            <th scope="col" align='center' className={`px-2 py-0.5 border border-slate-600 ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                }`}>{language === 'Eng' ? "Debit Amount" : "डेबिट रकम "}</th>
                            <th scope="col" align='center' className={`px-2 py-0.5 border border-slate-600 ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                }`}>{language === 'Eng' ? "Credit Amount" : "क्रेडिट रकम"}</th>
                            <th scope="col" align='center' className={`px-2 py-0.5 border border-slate-600 ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                }`}>{language === 'Eng' ? "Sub Ac Balance" : "ब्यालेन्स"}</th>
                            <th scope="col" align='center' className={`px-2 py-0.5 border-y border-slate-600 ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                }`}>{language === 'Eng' ? "Dr/Cr" : "डे./क्रे. "}</th>
                        </tr>
                    </thead>
                    <tbody>
                        {ledgerList?.map((ledger: any, index: number) => (
                            <tr key={index} className={`bg-white select-none border-b font-public-sans font-medium text-[11px] text-gray-800`}>
                                <td align='center' className="px-2 py-0.5 whitespace-nowrap border-y border-slate-600 font-normal">
                                    {index + 1}.</td>
                                <td className={`px-2 py-0.5 border border-slate-600 ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}>{ledger?.dated}</td>
                                <td align='center' className={`px-2 py-0.5 border border-slate-600 font-normal ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}>{ledger?.billrno ? ledger?.billrno : 0}</td>
                                <td align='center' className={`px-2 py-0.5 border border-slate-600 font-normal ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}>{ledger?.tsn ? ledger?.tsn : 0}</td>
                                <td className={`px-2 py-0.5 font-normal border border-slate-600 ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}>{language === "Eng" ? ledger?.particulars : ledger?.particunamedev}</td>
                                <td align='right' className={`px-2 py-0.5 font-normal border border-slate-600 ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}>{ledger?.dramt ? formatMoney_2(ledger?.dramt) : formatMoney_2(0)}</td>
                                <td align='right' className={`px-2 py-0.5 font-normal border border-slate-600 ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}>{ledger?.cramt ? formatMoney_2(ledger?.cramt) : formatMoney_2(0)}</td>
                                <td align='right' className={`px-2 py-0.5 font-normal border border-slate-600 ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}>{ledger?.subaccbal ? formatMoney_2(ledger?.subaccbal) : formatMoney_2(0)}</td>
                                <td align='center' className={`px-2 py-0.5 font-normal border-y border-slate-600 ${language === 'Eng' ? "font-public-sans" : "font-nepali"
                                    }`}>{language === 'Eng' ? ledger?.subdrcr : ledger?.subdrcr === "Dr" ? "डे." : "क्रे."}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    )
}

export default PrintLedgerView